import axios from 'axios';
import './SendSurveyButton.css';
import { useNavigate } from 'react-router-dom';

const SendSurveyButton = ({ survey, id, setErrorMessage }) => {
  const navigate = useNavigate();

  const handleSendForm = () => {
    const apiPutUrl = process.env.REACT_APP_PUT_AVALIACOM_API_URL;
        axios.put(`${apiPutUrl}/${id}`, {
        value: survey.score,
        reason_id: survey.reason_id,
        reason_option_id: survey.reason_option_id,
        comment: survey.comment
        })
        .then(response => {
            setErrorMessage(null);
            navigate('/thanks');
        })
        .catch(error => {
            if (error.response && error.response.status === 400 && error.response.data.error === "Pesquisa já preenchida causa") {
            navigate('alreadyAnswred');
            setErrorMessage(`Erro: ${error.response.data.message}`);
            } else {
            setErrorMessage('Erro ao enviar os dados. Tente novamente mais tarde.');
            }
        });
  };

  return (
      <button className="button-send"
        onClick={handleSendForm}
      >
        Enviar
      </button>  
      );
};
export default SendSurveyButton;
